import { apiClient } from '../config/client';
import { API_ENDPOINTS } from '../constants/endpoints';
const { AUTH } = API_ENDPOINTS;

export const login = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { url, method } = AUTH.login();
      const res = await apiClient({ url: url, data: payload, method });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const register = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { url, method } = AUTH.register();
      const res = await apiClient({ url: url, data: payload, method });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};
export const verifyGst = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { url, method } = AUTH.verifyGst();
      const res = await apiClient({ url: url, data: payload, method });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const changeFirstPassword = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { url, method } = AUTH.changeFirstPassword();
      const res = await apiClient({ url: url, data: payload, method });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const getBussinessCategory = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { url, method } = AUTH.getBussinessCategory();
      const res = await apiClient({ url: url, data: payload, method });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const getProfile = async (params) => {
  try {
    const { url, method } = AUTH.getProfile();
    const res = await apiClient({ url, method, params });
    return res;
  } catch (error) {
    return error;
  }
};

// export const postBillingDetails = async (payload) => {
//   try {
//     const [url, method] = ['/api/v1/billing/details', 'POST'];
//     const res = await apiClient({ url, method, data: payload });
//     return res;
//   } catch (error) {
//     return error;
//   }
// };

export const postBillingDetails = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const [url, method] = ['/api/v1/billing/details', 'POST'];
      const res = await apiClient({ url, method, data: payload });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const forgotPassword = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { url, method } = AUTH.forgotPassword();
      const res = await apiClient({ url: url, data: payload, method });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const resetPassword = (payload, token, type) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { url, method } = AUTH.resetPassword(token, type);
      const res = await apiClient({ url: url, data: payload, method });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};

export const refreshToken = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { url, method } = AUTH.refreshToken();
      const res = await apiClient({ url: url, data: payload, method });
      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
};
export default {
  login,
  register,
  changeFirstPassword,
  getBussinessCategory,
  getProfile,
  postBillingDetails,
  forgotPassword,
  resetPassword,
};
